import request from "@/utils/request";

export function getDevOpsPage(pageNum,pageSize,data) {
    return request({
        url: `/devOps/list`,
        method: 'post',
        params: { pageNum: pageNum,pageSize:pageSize },
        data:data
    })
}
